function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#report_inbox_activity_svg__clip0_610_14675)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 8a8 8 0 018-8h24a8 8 0 018 8v24a8 8 0 01-8 8H8a8 8 0 01-8-8V8z",
  fill: "#CDF9F5"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.12,
  d: "M29.515 23.94L30 22h-3.287c-.627 0-.94 0-1.224.086a2 2 0 00-.689.369c-.229.188-.403.449-.75.97l-.1.15c-.347.521-.521.782-.75.97a2.002 2.002 0 01-.69.369c-.283.086-.596.086-1.223.086h-2.574c-.627 0-.94 0-1.224-.086a2 2 0 01-.689-.369c-.229-.189-.403-.449-.75-.97l-.1-.15c-.347-.521-.521-.782-.75-.97a2.001 2.001 0 00-.69-.369C14.228 22 13.915 22 13.288 22H10l.485 1.94c.542 2.167.812 3.25 1.416 4.057a5 5 0 002.066 1.613c.93.39 2.046.39 4.28.39h3.507c2.233 0 3.35 0 4.279-.39a5 5 0 002.065-1.613c.604-.807.875-1.89 1.417-4.057z",
  fill: "#00B8A9",
  stroke: "#00B8A9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.5 22h2.787c.626 0 .94 0 1.224.086a2 2 0 01.688.369c.23.188.403.449.75.97l.1.15c.348.521.522.782.751.97a2 2 0 00.69.369c.283.086.596.086 1.222.086h2.575c.626 0 .94 0 1.224-.086a2 2 0 00.688-.369c.23-.189.403-.449.75-.97l.1-.15c.348-.521.522-.782.751-.97.203-.167.437-.292.69-.369.283-.086.596-.086 1.222-.086H29.5M17 15h6m-5 4h4m-10.515-2.94l-.616 2.464c-.14.562-.21.843-.267 1.123a12 12 0 000 4.706c.056.28.126.561.267 1.123.175.7.262 1.05.38 1.35a5 5 0 004.012 3.133c.32.041.68.041 1.402.041h6.674c.721 0 1.082 0 1.402-.041a5 5 0 004.011-3.133c.118-.3.206-.65.38-1.35.141-.562.212-.843.268-1.123.31-1.553.31-3.153 0-4.706-.056-.28-.127-.561-.267-1.123l-.616-2.464c-.542-2.167-.813-3.25-1.417-4.057a5 5 0 00-2.065-1.613c-.93-.39-2.046-.39-4.28-.39h-1.507c-2.233 0-3.35 0-4.279.39a5 5 0 00-2.065 1.613c-.604.807-.875 1.89-1.417 4.057z",
  stroke: "#00B8A9",
  strokeWidth: 1.5,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 27,
  cy: 11,
  r: 4,
  fill: "#00B8A9",
  stroke: "#CDF9F5",
  strokeWidth: 2
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "report_inbox_activity_svg__clip0_610_14675"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h40v40H0z"
})));

var SvgReportInboxActivity = function SvgReportInboxActivity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), _ref, _ref2);
};

export default SvgReportInboxActivity;